// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-label {
  margin-top: 30px;
  color: #6a6a6a;
  font-size: 16px;
}

.buttons-group {
  margin-top: 16px;
}

.modal-btn {
  display: flex;
  height: 50px;
  padding: 8px 60px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-top: 30px;
}

.campaign-goals {
  gap: 0.5rem;
  margin-bottom: 10px;
}

.button-col {
  margin-right: 10px;
}

.goal-btn {
  border: 1px solid;
  border-color: #000 !important;
  background: #fff;
}

.goal-btn:hover,
.goal-btn:active {
  background-color: #d2042d !important;
  color: #fff !important;
  border: none !important;
}

.goal-btn:active {
  background-color: #d2042d !important;
  border: none !important;
}

@media (max-width: 576px) {
  .campaign-goals {
    margin-bottom: 0px;
  }

  .campaign-goals .ant-col {
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/NewCampaignModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".modal-label {\n  margin-top: 30px;\n  color: #6a6a6a;\n  font-size: 16px;\n}\n\n.buttons-group {\n  margin-top: 16px;\n}\n\n.modal-btn {\n  display: flex;\n  height: 50px;\n  padding: 8px 60px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-top: 30px;\n}\n\n.campaign-goals {\n  gap: 0.5rem;\n  margin-bottom: 10px;\n}\n\n.button-col {\n  margin-right: 10px;\n}\n\n.goal-btn {\n  border: 1px solid;\n  border-color: #000 !important;\n  background: #fff;\n}\n\n.goal-btn:hover,\n.goal-btn:active {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  border: none !important;\n}\n\n.goal-btn:active {\n  background-color: #d2042d !important;\n  border: none !important;\n}\n\n@media (max-width: 576px) {\n  .campaign-goals {\n    margin-bottom: 0px;\n  }\n\n  .campaign-goals .ant-col {\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
